import React from 'react';

//interfaces
import { IConditionalOptions } from '../../interfaces/IConditionalLogicPanel';
import { IconLibrary } from '../../../../interfaces/icon/IconLibrary';

//components
import BasicButton from '../../../global/buttons/BasicButton';
import ToggleSelectButton from '../../../global/buttons/ToggleSelectButton';
import IconButton from '../../../global/buttons/IconButton';



const ToggleConditionalValue = ({conditions, onAddConditionalValueClick } : {conditions: IConditionalOptions[], onAddConditionalValueClick?: () => void} ) => {
    return (
        <div className="toggle-item">
            {conditions.map((toggle: IConditionalOptions, index) => (
                <div key={`${index}-${toggle.id}`} className={`${index !== 0 && "toggle-wrapper"}`}>
                    {index === 0 &&   
                        <h2 className="toggle-label">{toggle.label || " "}</h2>
                    }
                    <span className="toggle-option">
                        {index !== 0 &&  
                            <IconButton 
                                className="cancel-option-button" 
                                ariaLabel={''} 
                                onButtonClick={() => toggle.removeOption?.()}
                                iconName={IconLibrary.CIRCLE_CLOSE} 
                            />
                        }

                        <ToggleSelectButton
                            selectedItem={toggle.selectedItem}
                            defaultTitle={toggle.defaultTitle || ""}
                            ariaLabel={toggle.ariaLabel}
                            buttonList={toggle.buttonList}
                        />
                    </span>
                </div>
            ))}

            <BasicButton
                className="add-toggle-button"
                content={<><span className='add-icon'>+</span>or</>}
                ariaLabel="add an additional OR condition"
                onButtonClick={() => onAddConditionalValueClick?.()}
            />
        </div>
    )
};

export default ToggleConditionalValue